import { render, staticRenderFns } from "./IconWithTooltip.vue?vue&type=template&id=889804ec&scoped=true&"
import script from "./IconWithTooltip.vue?vue&type=script&lang=ts&"
export * from "./IconWithTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./IconWithTooltip.vue?vue&type=style&index=0&id=889804ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889804ec",
  null
  
)

export default component.exports